<template>
  <div class="color-section">
    <header class="color-section__header">
      <img
        v-if="iconSrc"
        :src="iconSrc"
        :alt="title"
        class="color-section__icon"
      />
      <h3
        v-if="title"
        class="color-section__title"
      >{{ title }}</h3>
    </header>
    <div
      v-if="colorPickers"
      class="color-section__body"
    >
      <color-picker
        v-for="(picker, index) in colorPickers"
        :key="index"
        :colors="picker.Colors"
        :title="picker.Title"
      ></color-picker>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'
import Component from "vue-class-component"
import { Prop } from 'vue-property-decorator'
import ColorPicker from '@/components/color-picker/color-picker.vue'
//
@Component({
  components: {
    'color-picker': ColorPicker
  }
})
export default class ColorSection extends Vue {
  @Prop() colorPickers
  @Prop() iconSrc
  @Prop() id
  @Prop() title


  mounted() {
  }


}
</script>
